/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.17.0
 */

import { useCallback, useEffect, useRef } from 'react';

import { FormikProps } from 'formik';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';

import { EReportScheduleField, IReportScheduleData } from '@components/common/ReportSchedule/types';
import { EWizardAdditionalReports } from '@pages/WizardAdditionalReports/wizardAdditionalReportsConsant';
import { IRootReducer } from '@reducers/rootReducer';

import { ReportSchedule } from '../../../components/common';
import { autoReportIdGetTabMetaStartAction, autoReportIdUpdateScheduleAction } from '../actions';
import { IAutoReportIdReducer } from '../reducer';
import { makeSelectorAutoReportIdScheduleMeta } from '../selectors';
import { EPageAutoReportIdInfo, IAutoReportIdGetTabMetaStartPayload } from '../types';


const AutoReportIdScheduleParameters = ({
                                            getTabMeta,
                                            scheduleMeta,
                                            updateSchedule,
                                        }: IDispatchToProps & IConnectedProps) => {

    const formRef = useRef<FormikProps<IReportScheduleData>>(null);

    useEffect(() => {
        getTabMeta({ tabId: EPageAutoReportIdInfo.ScheduleParameters });
    }, [getTabMeta]);

    const onSubmit = useCallback((data: IReportScheduleData) => {
        updateSchedule(data);
    }, [updateSchedule]);

    return (
        <ReportSchedule
            initialValue={scheduleMeta}
            isNewSubscribersReport={
                scheduleMeta[EReportScheduleField.ReportType] === EWizardAdditionalReports.REPORT_SUBSCRIBERS_NEW
            }
            ref={formRef}
            onSubmit={onSubmit}
        />
    );
};

type IConnectedProps = Pick<IAutoReportIdReducer, 'scheduleMeta'>

const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    scheduleMeta: makeSelectorAutoReportIdScheduleMeta(),
});

interface IDispatchToProps {
    getTabMeta: (payload: IAutoReportIdGetTabMetaStartPayload) => void;
    updateSchedule: (payload: IReportScheduleData) => void;
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatchToProps => ({
    getTabMeta: payload => dispatch(autoReportIdGetTabMetaStartAction(payload)),
    updateSchedule: payload => dispatch(autoReportIdUpdateScheduleAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AutoReportIdScheduleParameters);
